<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="秒杀商品" prop="merchId">
                        <form-lookup
                            v-model="info.merchId"
                            placeholder
                            title="选择商品"
                            textSymbol="merchName"
                            valueSymbol="id"
                            :modalHeight="600"
                            :modalWidth="900"
                            :options.sync="merchOptions"
                        >
                            <select-merch :id="info.id"></select-merch>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="秒杀名称" prop="sellName">
                        <Input v-model="info.sellName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="分类名称" prop="catalogId">
                        <Select v-model="info.catalogId" disabled placeholder>
                            <Option v-for="(item, index) in catalogList" :value="item.id" :key="index">{{ item.title }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="活动开始时间" prop="startTime">
                        <Select v-model="info.startTime" transfer style="width: 100%" placeholder="请选择开始时间">
                            <Option v-for="(item, index) in stimeList" :value="item.id" :key="index">{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="活动结束时间" prop="endTime">
                        <Select v-model="info.endTime" placeholder disabled style="width: 100%">
                            <Option v-for="(item, index) in etimeList" :value="item.id" :key="index">{{ item.text }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="秒杀价" prop="actAmount">
                        <input-number v-model="info.actAmount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="原价">
                        <input-number v-model="info.originalPrice" placeholder disabled>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="库存" prop="storeNum">
                        <input-number v-model="info.storeNum" placeholder="0~99999" :max="99999" :min="0" :allowDecimal="false"></input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="已售" prop="soldNum">
                        <input-number v-model="info.soldNum" placeholder="0~99999" :max="99999" :min="0" :allowDecimal="false"></input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="限购数" prop="limitNum">
                        <input-number v-model="info.limitNum" placeholder :allowDecimal="false"></input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="状态" prop="enabled">
                        <i-switch v-model="info.enabled" size="large" :true-value="1" :false-value="0">
                            <span slot="open">上线</span>
                            <span slot="close">下线</span>
                        </i-switch>
                    </FormItem>
                </Col>
            </Row>
            <!-- <Row :gutter="20">
								<Col span="24">
										<FormItem label="秒杀介绍" prop="remark">
												<quill-editor v-model="info.remark" placeholder></quill-editor>
										</FormItem>
								</Col>
						</Row>
						<Row :gutter="20">
								<Col span="24">
										<FormItem label="秒杀图片" prop="attachments">
												<preview-upload
														v-model="info.attachments"
														multiple
														:format="imgSuffix"
														:maxNumber="5"
												></preview-upload>
										</FormItem>
								</Col>
						</Row>-->
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="是否推荐" prop="recommend">
                        <i-switch v-model="info.recommend" size="large" :true-value="1" :false-value="0">
                            <span slot="open">是</span>
                            <span slot="close">否</span>
                        </i-switch>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { merchSellView, merchSellAdd, merchSellUpdate, chooseList } from "@/api/merch-sell";
import { catalogList } from "@/api/merch";
import Enum from "_u/enum";
import QuillEditor from "_c/quill-editor";
import PreviewUpload from "_c/preview-upload";
import config from "@/config";
import { ymdL, toDate } from "_u/helper";
import dayjs from "dayjs";
import SelectMerch from "_vc/select-merch";

export default {
    name: "g-act-ms-form",

    props: {
        id: {
            type: [String, Number],
            default: "",
        },
    },

    components: { QuillEditor, PreviewUpload, SelectMerch },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                merchId: "", // 秒杀商品
                sellName: "", // 秒杀名称
                catalogId: "", // 商品分类
                storeNum: "", //库存
                soldNum: "", //已售
                sellMode: "2", //秒杀
                startTime: "", // 开始时间
                endTime: "", // 结束时间
                originalPrice: "", //原价
                actAmount: "", // 秒杀价d
                limitNum: 1, // 限购数
                enabled: 0, // 状态
                // remark: "", // 秒杀介绍
                // attachments: "", // 秒杀图片
                recommend: 0, // 是否推荐
                ver: "", // 版本号
            },
            merchList: [],
            imgSuffix: config.upload.imgSuffix,
            catalogList: [], // 分类列表
            optionsDate: {
                disabledDate(date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                },
            },
            attachments: "", // 秒杀图片
            merchOptions: [],
            followKeys: ["catalogId", "merchId", "originalPrice", "storeNum", "soldNum"],
        };
    },

    computed: {
        ruleValidate() {
            return {
                merchId: [{ required: true, message: "秒杀商品必填" }],
                sellName: [{ required: true, message: "秒杀名称必填" }],
                startTime: [{ required: true, message: "活动时间必填" }],
                actAmount: [{ required: true, message: "秒杀价必填" }],
                limitNum: [{ required: true, message: "限购数必填" }],
                storeNum: [{ required: true, message: "库存必填" }],
                soldNum: [{ required: true, message: "已售必填" }],
                // remark: [{ required: true, message: "秒杀介绍必填" }],
                // attachments: [{ required: true, message: "秒杀图片必填" }]
            };
        },
        stimeList() {
            var timeList = [];
            for (var i = 0; i <= 23; i++) {
                var body = {
                    id: i < 10 ? "0" + i + ":00" : i + ":00",
                    text: i < 10 ? "0" + i + ":00" : i + ":00",
                };
                i = i + 1;
                timeList.push(body);
            }
            return timeList;
        },
        etimeList() {
            var timeList = [];
            for (var i = 0; i <= 23; i++) {
                var body = {
                    id: i < 10 ? "0" + i + ":00" : i + ":00",
                    text: i < 10 ? "0" + i + ":00" : i + ":00",
                };
                i = i + 1;
                timeList.push(body);
            }
            return timeList;
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return merchSellView(this.id);
            } else {
                return Promise.resolve();
            }
        }
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch(), chooseList({ nopage: 1 }), catalogList({ pageNo: 1, pageSize: 999 })])
                .then((args) => {
                    var [view, merch, catalogList] = args;
                    if (view) {
                        var viewData = view.data;
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity;
                        Object.keys(this.info).forEach((name) => (this.info[name] = viewData[name]));
                        this.info.actAmount /= 100;
                    }
                    if (merch && merch.data) {
                        this.merchOptions = merch.data.list;
                        this.merchList=merch.data.list
                    }

                    this.catalogList = catalogList.data.page.list || [];
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({ attachments: this.attachments }, this.info);
                    formData.actAmount *= 100;
                    if (this.id) {
                        return merchSellUpdate(formData);
                    } else {
                        return merchSellAdd(formData);
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t("tips.update.success"));
                    } else {
                        this.$Message.success(this.$t("tips.add.success"));
                    }
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
    watch: {
        "info.merchId": function(el) {
            if (el) {
                var merch = this.merchList.find((v) => v.id == el);
                if (merch) {
                    this.info.originalPrice = merch.originalPrice/100;
                    this.info.catalogId=merch.catalogId
                    if(!this.info.storeNum){
                        this.info.storeNum=merch.storeNum
                    }
                    if(!this.info.soldNum){
                        this.info.soldNum=merch.soldNum
                    }
                }
            }
        },
        "info.startTime": function(val) {
            var index = 0;
            for (var i = 0; i < this.etimeList.length; i++) {
                if (this.etimeList[i].id == val) {
                    index = i;
                }
            }
            if (index == this.etimeList.length - 1) {
                index = 0;
            } else {
                index = index + 1;
            }
            this.info.endTime = this.etimeList[index].id;
        },
    },
};
</script>
<style lang="less" scoped></style>
